import { render, staticRenderFns } from "./putStorage.vue?vue&type=template&id=1bfa7a35&scoped=true&"
import script from "./putStorage.vue?vue&type=script&lang=js&"
export * from "./putStorage.vue?vue&type=script&lang=js&"
import style0 from "./putStorage.vue?vue&type=style&index=0&id=1bfa7a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa7a35",
  null
  
)

export default component.exports